// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refDataSensitivityService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refDataSensitivities/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refDataSensitivities/${id}`).then(handleResponse);
}

function add(refDataSensitivity) {
    return axios.post('/refDataSensitivities', refDataSensitivity).then(handleResponse);
}

function update(refDataSensitivity) {
    return axios.put(`/refDataSensitivities/${refDataSensitivity.refDataSensitivityId}`, refDataSensitivity).then(handleResponse);
}

function deleteEntity(refDataSensitivity) {
    return axios.delete(`/refDataSensitivities/${refDataSensitivity.refDataSensitivityId}`).then(handleResponse);
}
